import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CommandP2P,
  CommandP2PType,
  RemoveCommandP2P,
} from 'src/app/core/models/keepAliveFiles.model';

@Injectable({
  providedIn: 'root',
})
export class KeepAliveFilesService {
  private apiServerUrl = environment.loganConfig.url;
  constructor(private http: HttpClient) {}
  headers = new HttpHeaders().set('Content-Type', 'multipart/form-data');
  requestOptions: Object = {
    headers: this.headers,
    reportProgress: true,
    responseType: 'json',
  };

  public getLastFile(): Observable<any> {
    return this.http.get<any>(`${this.apiServerUrl}/keepAliveFiles/lastFile`);
  }
  public getCommandP2PType(): Observable<CommandP2PType> {
    return this.http.get<CommandP2PType>(
      `${this.apiServerUrl}/keepAliveFiles/getCommandType`
    );
  }

  public addCommands(commands: CommandP2P[]): Observable<any> {
    return this.http.post<CommandP2PType[]>(
      `${this.apiServerUrl}/keepAliveFiles/newCommandP2P`,
      commands,
      { withCredentials: true }
    );
  }

  public removeDeviceCommands(commands: RemoveCommandP2P): Observable<any> {
    return this.http.post<RemoveCommandP2P>(
      `${this.apiServerUrl}/keepAliveFiles/removeDeviceCommandP2P`,
      commands,
      { withCredentials: true }
    );
  }

  public getDevicesCanDownload(): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/keepAliveFiles/getDevicesCacheCanDownload`
    );
  }
  public addDevicesCanDownload(seriais: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/keepAliveFiles/insertDevicesCacheCanDownload`,
      seriais,
      { withCredentials: true }
    );
  }
  public zeroTimerDevicesCanDownload(serial: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/keepAliveFiles/zeroTimerDeviceCacheCanDownload`,
      serial,
      { withCredentials: true }
    );
  }

  public removeDevicesCanDownload(serial: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/keepAliveFiles/removeDeviceCacheCanDownload`,
      serial,
      { withCredentials: true }
    );
  }
}
